/* Russian copy for the admin web. Kept inline (not JSON) so TypeScript
   catches missing keys at compile time via the `Resources` type below. */

export const ru = {
  common: {
    app_name: 'Twin Turbo Admin',
    sign_out: 'Выйти',
    account: 'Аккаунт',
    loading: 'Загрузка…',
    error_generic: 'Что-то пошло не так. Попробуйте ещё раз.',
    create: 'Создать',
    edit: 'Изменить',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    confirm_delete: 'Удалить',
    actions: 'Действия',
    empty: 'Пусто.',
    copy: 'Копировать',
    copied: 'Скопировано',
    close: 'Закрыть',
    no_access_title: 'Нет доступа',
    no_access_body: 'У вашей роли нет прав на этот раздел. Обратитесь к администратору.',
    reload: 'Обновить',
    reloading: 'Обновляем страницу…',
    page_load_failed_title: 'Страница не загрузилась',
    page_load_failed_body:
      'Не удалось скачать часть админки — обычно это обрыв связи. Обновите страницу; если не поможет — закройте вкладку и откройте админку заново.',
    page_error_title: 'Что-то пошло не так',
    page_error_body: 'Обновите страницу. Если ошибка повторится, пришлите снимок этого экрана.',
  },
  notifications: {
    enable: 'Включить уведомления',
    disable: 'Выключить уведомления',
    blocked: 'Уведомления заблокированы в браузере',
    blocked_tooltip: 'Уведомления заблокированы в браузере. Нажмите, чтобы узнать, как включить',
    blocked_how:
      'Нажмите на значок слева от адреса сайта → «Уведомления» → «Разрешить». Колокольчик включится сам.',
    refused: 'Браузер не дал разрешение на уведомления',
    refused_how:
      'Нажмите на колокольчик ещё раз и выберите «Разрешить». Если окна нет — значок слева от адреса сайта → «Уведомления» → «Разрешить».',
    failed: 'Не получилось включить уведомления',
    failed_how: 'Проверьте связь и нажмите на колокольчик ещё раз.',
  },
  pwa: {
    install: 'Установить приложение',
  },
  pwa_update: {
    available: 'Доступно обновление',
    later: 'Позже',
    reload: 'Обновить',
  },
  auth: {
    login_title: 'Вход',
    login_subtitle: 'Диспетчеры и кабинеты клиентов',
    username: 'Логин',
    password: 'Пароль',
    remember_me: 'Запомнить меня',
    submit: 'Войти',
    error_invalid_credentials: 'Неверный логин или пароль.',
    error_rate_limited: 'Слишком много попыток. Подождите 15 минут.',
    error_account_locked: 'Аккаунт заблокирован. Обратитесь к администратору.',
    error_network: 'Нет связи с сервером.',
    or: 'или',
    session_expired: 'Сессия истекла. Войдите снова.',
  },
  webauthn: {
    login_button: 'Войти по Face ID',
    register_prompt_title: 'Включить вход по Face ID?',
    register_prompt_body:
      'В следующий раз можно будет войти по биометрии этого устройства — без пароля.',
    register_confirm: 'Включить',
    register_dismiss: 'Не сейчас',
    register_error: 'Не удалось зарегистрировать Face ID. Попробуйте ещё раз.',
    manage_title: 'Face ID / Touch ID',
    credentials_empty: 'Face ID не подключён на других устройствах.',
    credential_created: 'Добавлено',
    credential_last_used: 'Последний вход',
    credential_never_used: 'ещё не использован',
    delete: 'Удалить',
    delete_error: 'Не удалось удалить.',
  },
  nav: {
    dashboard: 'Главная',
    orders: 'Заказы',
    map: 'Карта',
    operators: 'Водители',
    providers: 'Провайдеры',
    clients: 'Клиенты',
    catalog: 'Справочники',
    consumers: 'Клиенты B2C',
    consumer_zones: 'Города B2C',
    pricing: 'Цены',
    personal_car_settings: 'Отмена и no-show',
    stuck_deliveries: 'Незавершённые операции',
    refill_requests: 'Дозаправки',
    chat: 'Чат',
    reports: 'Отчёты',
    report_builder: 'Конструктор',
    admins: 'Пользователи',
    admin_roles: 'Роли и права',
  },
  layout: {
    sidebar_label: 'Главная навигация',
    section_main: 'Основное',
    section_admin: 'Администрирование',
    section_other: 'Прочее',
    collapse_sidebar: 'Свернуть меню',
    expand_sidebar: 'Развернуть меню',
    open_menu: 'Открыть меню',
    menu: 'Меню',
  },
  dashboard: {
    placeholder: 'Список заказов — в разделе «Заказы», карта водителей — в разделе «Карта».',
    subtitle: 'Оперативная сводка по смене',
    kpi_active: 'Активные заказы',
    kpi_problem: 'Проблемные',
    kpi_online: 'Водители онлайн',
    kpi_providers: 'Провайдеры',
    kpi_total: 'всего',
    kpi_of: 'из',
    recent_orders: 'Последние заказы',
    by_provider: 'По провайдерам',
    by_fuel_type: 'По видам топлива',
    breakdown_empty: 'Нет данных.',
    donut_total_label: 'активных',
    today: 'сегодня',
    now_title: 'Сейчас в работе',
    summary_title: 'Сводка',
    summary_subtitle: 'Все заказы по провайдерам за выбранные даты',
    summary_preset_today: 'Сегодня',
    summary_preset_yesterday: 'Вчера',
    summary_preset_d7: '7 дней',
    summary_preset_d30: '30 дней',
    summary_preset_all: 'Всё время',
    summary_presets_label: 'Быстрый выбор дат',
    summary_from: 'с',
    summary_to: 'по',
    summary_range_day: '{{day}}, 00:00 — 23:59',
    summary_range_span: '{{from}} 00:00 — {{to}} 23:59',
    summary_metric_new_orders: 'Новые заказы',
    summary_metric_completed: 'Заправки',
    summary_metric_liters: 'Литры',
    summary_metric_revenue: 'Выручка',
    summary_metric_new_consumers: 'Новые клиенты',
    summary_metric_new_consumers_note: 'личный автомобиль',
    summary_average_check: 'Средний чек',
    summary_rating: 'Оценка водителей',
    summary_rating_none: 'оценок нет',
    summary_by_hour: '{{metric}} по часам',
    summary_by_day: '{{metric}} по дням',
    summary_by_week: '{{metric}} по неделям',
    summary_panel_title: 'За выбранные даты',
    summary_panel_hint: 'Нажми на строку — покажу на графике',
    summary_compare_yesterday: 'вчера',
    summary_compare_day_before: 'накануне',
    summary_compare_before: 'было',
    summary_compare_hint_today: 'сравнение — со вчера целиком',
    summary_compare_hint_day: 'сравнение — с днём раньше',
    summary_compare_hint_span: 'было — за столько же дней до этого',
    summary_compare_hint_all: 'с первого дня — сравнивать не с чем',
    summary_chart_hint:
      'Наведи на столбик — разбивка по провайдерам. Клик по дню — завершённые заказы этого дня.',
    summary_now: 'сейчас {{time}}',
    summary_empty_today_new_orders: 'Сегодня новых заказов пока нет',
    summary_empty_today_completed: 'Сегодня заправок пока нет',
    summary_empty_today_liters: 'Сегодня топливо пока не наливали',
    summary_empty_today_revenue: 'Сегодня выручки пока нет',
    summary_empty_today_new_consumers: 'Сегодня новых клиентов пока нет',
    summary_empty_past_new_orders: 'За эти даты новых заказов не было',
    summary_empty_past_completed: 'За эти даты заправок не было',
    summary_empty_past_liters: 'За эти даты топливо не наливали',
    summary_empty_past_revenue: 'За эти даты выручки не было',
    summary_empty_past_new_consumers: 'За эти даты новых клиентов не было',
    summary_empty_hint_today: 'Вчера, 30 дней и всё время — кнопками сверху.',
    summary_empty_hint_past: 'Выбери другие даты сверху.',
    summary_tooltip_total: 'Всего',
    summary_tooltip_partial: 'день не закончен',
    summary_tooltip_other:
      'Новых заказов {{orders}} · заправок {{done}} · новых клиентов {{clients}}',
    summary_tooltip_cta: 'Завершённые заказы за {{day}} →',
    summary_consumers_only_personal: 'клиенты с приложением бывают только у личного автомобиля',
    summary_bar_label: '{{when}}: {{metric}} {{value}}',
    funnel_title: 'Путь клиента · личный автомобиль',
    funnel_hint: 'все клиенты с запуска, от выбранных дат не зависит',
    funnel_step_registered: 'Зарегистрировались',
    funnel_step_added_car: 'Добавили машину',
    funnel_step_reached_payment: 'Дошли до оплаты',
    funnel_step_ordered: 'Оформили заказ',
    funnel_step_refueled: 'Заправились',
    funnel_step_refueled_again: 'Заправились ещё раз',
    funnel_lost: '−{{count}} чел.',
    funnel_insight: 'Больше всего теряем на шаге «{{step}}»: дошли {{count}} из {{prev}}.',
    live_feed: 'Живая лента',
    live_feed_empty: 'Пока нет событий — появятся сразу, как только что-то произойдёт.',
    live_feed_generic: 'Заказ обновлён',
    attention_queue: 'Требует внимания',
    attention_queue_empty: 'Ничего не требует внимания.',
    attention_urgent: 'срочно, не назначен',
    attention_after_intake: 'приём закрыт, не взят',
    attention_after_intake_hint:
      'Заказ клиента никто не взял, а приём «Срочно» и «Ближайшей» уже закрыт. Заправщики не закроют смену, пока его не возьмут.',
    elapsed_just_now: 'только что',
    elapsed_minutes: '{{count}} мин',
    elapsed_hours: '{{count}} ч',
    elapsed_days: '{{count}} дн',
    online_roster: 'Сейчас на линии',
    online_roster_empty: 'Никого нет на линии.',
    online_roster_free: 'свободен',
  },
  orders: {
    title: 'Заказы',
    col_ref: 'Заказ',
    col_status_date: 'Дата',
    col_car: 'Госномер',
    col_state: 'Статус',
    col_operator: 'Водитель',
    col_fuel: 'Топливо',
    col_liters: 'Литры',
    col_actions: 'Действия',
    col_consumer: 'Клиент',
    consumer_chip: 'Клиент: {{email}}',
    scheduled_badge: 'Запланирован',
    scheduled_window: 'Окно доставки',
    scheduled_hint:
      'Заявка ждёт своего окна — водитель получит её к началу, назначать вручную не нужно.',
    scheduled_assign_confirm:
      'Заявка запланирована на {{window}}. Если назначить водителя сейчас, он поедет немедленно. Всё равно назначить?',
    fiscal_receipts: 'Чеки (54-ФЗ)',
    receipt_fd: 'ФД',
    receipt_fp: 'ФП',
    receipt_pending: 'Ожидает фискализации',
    receipt_failed: 'Чек не пробит',
    receipt_open: 'Открыть чек',
    // Те же слова, что на экране «Чек» у клиента: диспетчер и клиент называют один чек одинаково.
    receipt_trigger: {
      completion: 'Заправка',
      overflow_payment: 'Доплата за перелив',
      sbp_prepayment: 'Предоплата',
      paid_cancellation: 'Платная отмена',
      no_show: 'Клиент не вышел',
      refund: 'Возврат',
    },
    receipt_operation: {
      INCOME: 'Приход',
      INCOME_RETURN: 'Возврат прихода',
    },
    receipt_settlement: {
      FULL_PAYMENT: 'полный расчёт',
      ADVANCE: 'аванс',
      PREPAYMENT_OFFSET: 'зачёт аванса',
    },
    completed_on_chip: 'Выполнено {{date}}',
    filter_state: 'Статус:',
    filter_operator: 'Водитель:',
    filter_provider: 'Провайдер:',
    filter_origin: 'Тип:',
    filter_date_from: 'Дата от',
    filter_date_to: 'Дата до',
    search_car_placeholder: 'Поиск по госномеру…',
    filter_all: 'Все',
    origin_integration: 'Интеграция',
    origin_manual: 'Ручные',
    badge_urgent: 'Срочно',
    cars_title: 'Машины в выезде',
    cars_requested: 'просили',
    cars_poured: 'залито',
    cars_added_later: 'добавлена в пути',
    car_status_pending: 'ждёт заправки',
    car_status_refueled: 'заправлена',
    car_status_skipped: 'пропущена',
    car_status_cancelled: 'снята',
    badge_manual: 'Ручной',
    total: 'Всего: {{n}}',
    empty: 'Заказов не найдено.',
    prev: 'Назад',
    next: 'Вперёд',
    assign: 'Назначить',
    assign_select: 'Выбор водителя',
    assign_pick: '— водитель —',
    assign_mode_manual: 'ручной',
    cancel: 'Отменить',
    mark_error: 'Проблемный',
    approval_in_chat: 'В чат',
    show_on_map: 'Показать на карте',
    approve_start: 'Одобрить старт',
    reject_start: 'Отклонить старт',
    approve_completion: 'Одобрить завершение',
    reject_completion: 'Отклонить завершение',
    approve_problematic: 'Это новый заказ',
    reject_problematic: 'Отменить',
    history: 'История статусов',
    /* Неявка клиента. Водитель больше не закрывает такой заказ сам — он только докладывает, а
       решает диспетчер, и у него на это ровно тот бюджет, что тикает на экране. Формулировки
       написаны так, чтобы человек под таймером понял цену каждой кнопки без чтения инструкции. */
    no_show_title: 'Клиента нет у машины',
    no_show_waiting:
      'Водитель на месте, идёт ожидание клиента. Пока оно идёт, закрыть заказ не может никто.',
    no_show_reported: 'Водитель доложил: клиента нет у машины.',
    no_show_reported_at: 'Водитель доложил в {{at}}: клиента нет у машины.',
    no_show_countdown: 'До автоотмены {{time}}',
    no_show_no_deadline: 'Срок автоотмены неизвестен — решайте, не откладывая.',
    no_show_expired:
      'Время вышло — заказ закрывается автоматически, деньги вернутся клиенту за вычетом доставки.',
    no_show_cancelled:
      'Заказ закрыт как неявка: клиенту вернутся деньги за вычетом платы за доставку.',
    no_show_resolved: 'Ожидание закончилось — заказ ушёл дальше, решать больше нечего.',
    no_show_extra_granted: 'Доп. время уже дали в {{at}} — второй раз нельзя.',
    no_show_extra_too_late:
      'До автоотмены меньше минуты — время выдавать поздно: клиент получил бы обещание минуты, которой у него уже нет. Остаётся отменить заказ или дать автоотмене закрыть его самой.',
    no_show_cancel: 'Отменить заказ',
    no_show_extra: 'Дать доп. время',
    no_show_extra_minutes: 'Дать доп. время: {{minutes}} мин',
    no_show_cancel_title: 'Отменить заказ как неявку?',
    no_show_cancel_body:
      'Заказ закроется сразу: клиенту вернутся деньги за вычетом платы за доставку. Вернуть заказ обратно уже нельзя.',
    no_show_failed: 'Не получилось. Похоже, решение уже принято — проверьте, что с заказом.',
    fuel_amount: 'Объём',
    total_price: 'Сумма',
    coords: 'Координаты',
    truck: 'Бензовоз',
    copy_order_number: 'Скопировать номер заказа',
    copy_car_number: 'Скопировать госномер клиента',
    copy_truck_make: 'Скопировать марку бензовоза',
    copy_truck_plate: 'Скопировать госномер бензовоза',
    copy_coords: 'Скопировать координаты',
    copy_consumer_email: 'Скопировать почту клиента',
    write_to_consumer: 'Написать клиенту',
    invoice: 'Расчёт',
    invoice_fuel: 'Топливо',
    invoice_discount: 'Скидка клиента',
    invoice_discount_detail: 'топливо −{{fuel}} %, услуги −{{service}} %',
    invoice_total: 'Итого',
    videos: 'Видео заправки',
    videos_empty: 'Видео пока нет.',
    video_watch: 'Смотреть',
    video_download: 'Скачать',
    video_share: 'Копировать ссылку',
    video_share_copied: 'Ссылка скопирована',
    media: 'Видео и фото заправки',
    media_empty: 'Видео и фото пока нет.',
    media_video: 'Видео',
    media_photo: 'Фото',
    photo_open: 'Открыть',
    /* Russian label per OrderState wire value (crates/orders/src/states.rs) — all 41, see
       ALL_ORDER_STATES in entities/order/model.ts for the completeness check. Grouped to match
       the state machine's own lifecycle-stage comments. */
    state: {
      OPEN: 'Открыт',
      ADMIN_REQUESTED_PENDING: 'Предложен водителю',
      ADMIN_REQUESTED_TAKEN: 'Принят по назначению',
      ADMIN_REQUESTED_CANCELED: 'Отменён',

      OPERATOR_IN_WAY: 'В пути',
      OPERATOR_START_PENDING_APPROVAL: 'Ждёт одобрения старта',
      OPERATOR_ARRIVED: 'На месте',
      OPERATOR_ACCESS_CONFIRMED: 'Доступ к машине получен',

      OPERATOR_UNLOCK_REQUEST: 'Открывается',
      OPERATOR_UNLOCK_APPROVED: 'Машина открыта',
      OPERATOR_UNLOCK_FAILED: 'Не открылась',

      OPERATOR_REFILL_STARTED: 'Идёт заправка',
      OPERATOR_REFILL_FINISHED: 'Заправка завершена',
      OPERATOR_COMPLETION_PENDING_APPROVAL: 'Ждёт одобрения завершения',

      OPERATOR_ORDER_SUBMISSION_STARTED: 'Отправка провайдеру',
      OPERATOR_ORDER_SUBMISSION_FAILED: 'Ошибка отправки',
      OPERATOR_ORDER_SUBMISSION_COMPLETED: 'Отправлено провайдеру',

      OPERATOR_ORDER_CANCELLATION_STARTED: 'Отменяется водителем',
      OPERATOR_ORDER_CANCELLATION_FAILED: 'Ошибка отмены (водитель)',
      OPERATOR_ORDER_CANCELLATION_COMPLETED: 'Отменён водителем',

      PROVIDER_ORDER_CANCELLATION_STARTED: 'Отменяется провайдером',
      PROVIDER_ORDER_CANCELLATION_FAILED: 'Ошибка отмены (провайдер)',
      PROVIDER_ORDER_CANCELLATION_COMPLETED: 'Отменён провайдером',

      NEW_ORDER_RECEIVED_FOR_CAR: 'Заменён новым заказом',

      ADMINISTRATOR_FINISH_STARTED: 'Диспетчер завершает',
      ADMINISTRATOR_EXTERNAL_FINISH_STARTED: 'Диспетчер завершает (провайдер)',
      ADMINISTRATOR_EXTERNAL_FINISH_FAILED: 'Ошибка завершения (провайдер)',
      ADMINISTRATOR_EXTERNAL_FINISH_COMPLETED: 'Завершён диспетчером (провайдер)',
      ADMINISTRATOR_FINISH_COMPLETED: 'Завершён диспетчером',
      ADMINISTRATOR_FINISH_FAILED: 'Ошибка завершения',

      ADMINISTRATOR_UNLOCK_REQUEST: 'Диспетчер открывает',
      ADMINISTRATOR_UNLOCK_APPROVED: 'Диспетчер открыл',
      ADMINISTRATOR_UNLOCK_FAILED: 'Диспетчер не открыл',

      ADMINISTRATOR_LOCK_REQUEST: 'Диспетчер закрывает',
      ADMINISTRATOR_LOCK_APPROVED: 'Диспетчер закрыл',
      ADMINISTRATOR_LOCK_FAILED: 'Диспетчер не закрыл',

      PROBLEMATIC: 'Проблемный',
      EXPIRED: 'Просрочен',
      COMPLETED: 'Завершён',

      // Два терминальных состояния из B2C. Их не было в словаре вовсе, и заказ личного
      // автомобиля, отменённый клиентом, показывался в панели строкой
      // «CONSUMER_ORDER_CANCELLATION_COMPLETED» (репорт владельца 2026-08-24).
      CONSUMER_ORDER_CANCELLATION_COMPLETED: 'Отменён клиентом',
      CONSUMER_NO_SHOW: 'Не было доступа к машине',
    },
    // Fallback label for a status-history actor when the name can't be resolved (SYSTEM
    // step, or an actor the current admin can't look up). Vocabulary matches the app-wide
    // «Водитель»/«Диспетчер» rename — never the raw wire words.
    actor: {
      SYSTEM: 'Система',
      OPERATOR: 'Водитель',
      ADMINISTRATOR: 'Диспетчер',
      PROVIDER: 'Провайдер',
    },
  },
  // Оценки клиентов (владелец, 04.10.2026): карточка заказа, список заказов, лента на Главной,
  // счётчик у водителя. Плохая — 3 и ниже.
  ratings: {
    stars_aria: 'Оценка {{score}} из 5',
    score_of_five: '{{score}} из 5',
    low_badge: 'плохая оценка',
    no_comment: 'Без комментария',
    title_order: 'Оценка клиента',
    not_rated: 'Клиент не оценил заказ.',
    col: 'Оценка',
    filter: 'Оценка:',
    filter_rated: 'Оценённые',
    filter_low: 'Плохие (3 и ниже)',
    filter_open: 'Плохие, не разобраны',
    not_followed_up: 'Плохую оценку ещё не разобрали: с клиентом никто не связался.',
    not_followed_up_short: 'не разобрана',
    followed_up_short: 'связались',
    write_in_app: 'Написать в приложении',
    chat_draft:
      'Здравствуйте! Вы оценили заправку {{date}} на {{score}} из 5. Нам важно понять, что пошло не так, — расскажите, пожалуйста. Если удобнее поговорить, оставьте номер телефона, мы перезвоним.',
    mark_contacted: 'Связались',
    contacted_by: 'Связались {{at}} — {{who}}',
    someone: 'сотрудник',
    edit_note: 'Изменить заметку',
    note_label: 'Что выяснили',
    note_placeholder: 'Что сказал клиент и что сделали (необязательно)',
    save_contacted: 'Отметить: связались',
    feed_title: 'Отзывы клиентов',
    feed_filter: 'Какие отзывы показать',
    feed_filter_all: 'Все',
    feed_filter_low: 'Плохие',
    feed_filter_open: 'Не разобраны',
    feed_empty_all: 'Оценок пока нет.',
    feed_empty_low: 'Плохих оценок нет.',
    feed_empty_open: 'Все плохие оценки разобраны.',
    feed_driver: 'водитель {{name}}',
    open_count: 'не разобрано: {{count}}',
    open_count_hint: 'Плохие оценки за всё время, по которым с клиентом ещё не связались',
    contact: 'Связаться',
    show_more: 'Показать ещё',
    all_in_orders: 'Все оценки — в «Заказах» →',
  },
  map: {
    active_orders: 'Активных заказов: {{n}}',
    online_operators: 'Водителей на линии: {{n}}',
    unavailable: 'Карта недоступна (нет ключа Yandex JS API или ошибка загрузки).',
    assign_mode_banner: 'Режим назначения — выберите водителя на карте',
    assign_mode_cancel: 'Отмена',
    fullscreen: 'Во весь экран',
    exit_fullscreen: 'Свернуть',
  },
  catalog: {
    title: 'Справочники',
    fuel_types: 'Виды топлива',
    departments: 'Подразделения',
    fuel_stations: 'АЗС',
    refuel_cars: 'Бензовозы',
    equipment: 'Оборудование',
    administrative_levels: 'Регионы',
    mac: 'MAC',
    status: 'Статус',
    assigned_car: 'Машина',
    pick_car: 'Выберите бензовоз',
    equipment_status: {
      ACTIVE: 'На машине',
      SPARE: 'На складе',
      IN_SERVICE: 'На сервисе',
    },
    equipment_action: {
      assign: 'Поставить на машину',
      unassign: 'Снять',
      service: 'На сервис',
    },
    code: 'Код',
    name: 'Название',
    base_price: 'Базовая цена',
    color: 'Цвет',
    active: 'Активен',
    external_id: 'Внешний ID',
    external_id_kmazs: 'Код в КМАЗС (mpfind/mpadd)',
    receipt_name: 'Наименование в чеке',
    receipt_name_hint:
      'Как товар называется в кассовом чеке, например «Бензин АИ-95-К5». Пусто — в чек идёт «Название».',
    fuel_type: 'Топливо',
    lat: 'Широта',
    lon: 'Долгота',
    plate_number: 'Госномер',
    truck_make: 'Марка и модель',
    truck_brand: 'Марка',
    truck_model: 'Модель',
    truck_make_hint: 'Что видит клиент, пока машина едет: «Лада Ларгус · А123БВ777»',
    capacity_liters: 'Ёмкость',
    fuel_current: 'В цистерне',
    fuel_free: 'Свободно',
    fuel_measured: 'Уровнемер',
    fuel_delta: 'Расхождение',
    fuel_measured_at: 'Считано',
    fuel_never_read: 'ни разу',
    fuel_stale: 'устарело',
    fuel_untracked: 'нет данных',
    has_level_sensor: 'Уровнемер стоит',
    fuel_log: 'Движение топлива',
    fuel_event: {
      REFILL: 'Дозаправка',
      ORDER: 'Налив в заказ',
      ADJUSTMENT: 'Правка',
      MEASUREMENT_ACCEPTED: 'Принят замер',
    },
    admin_level: 'Уровень',
    parent: 'Родитель',
    region: 'Регион',
    decimal_hint: 'Дробное число, точка как разделитель (например, 1.50).',
    consumer_zones: 'Города B2C',
    city_label: 'Город',
    center: 'Центр (широта, долгота)',
    radius_km: 'Радиус, км',
    enabled: 'Включён',
    updated_at: 'Обновлён',
    zone_region_hint:
      'Регион определяет тариф: цены для города берутся из раздела «Цены» по этому региону.',
    zone_radius_hint: 'Радиус зоны обслуживания в километрах, от 0 до 500.',
    zone_enabled_hint:
      'Снимите галочку, чтобы временно закрыть область: контур, тариф и окна останутся, но клиент перестанет видеть её на карте и не сможет поставить сюда метку, а по этим адресам получит «не доставляем». Уже созданные заказы это не трогает. Это не удаление.',
    zone_coverage: 'Контур',
    zone_not_drawn: 'не нарисован',
    zone_map_open: 'На карте',
    zone_map_title: 'Что где работает',
    zone_map_layers_hint:
      'Кто выше в списке — тот и обслуживает точку там, где пятна перекрываются.',
    zone_map_topmost: 'сверху',
    zone_map_bottommost: 'снизу',
    zone_map_middle: 'посередине',
    zone_map_not_drawn: 'не нарисовано',
    zone_map_name: 'Название',
    zone_map_price: 'Доставка, ₽',
    zone_map_price_per_liter: 'За литр, ₽',
    zone_map_draw: 'Нарисовать',
    zone_map_cut: 'Вырезать',
    zone_map_cut_falls_through:
      'Вырез не отключит доставку: эту область по-прежнему накрывает {{names}}. Вырежьте её и там — или погасите то пятно.',
    zone_map_rings: 'Кольца Москвы — заготовки контура',
    zone_map_ring_outline: 'Обвести',
    zone_map_edit: 'Править контур',
    zone_map_save_shape: 'Сохранить пятно',
    zone_map_cancel: 'Отмена',
    zone_map_back: 'Назад',
    zone_map_restore_circle: 'Вернуть круг',
    zone_map_new_spot: '+ Новое пятно',
    zone_map_new_spot_title: 'Новое пятно',
    zone_map_new_spot_name: 'Название — для вас, не для клиента',
    zone_map_new_spot_name_hint:
      'Например «Москва до МКАД» и «Москва за МКАД»: у каждого пятна своя цена, а клиенту оба показываются как «Москва».',
    zone_map_new_spot_create: 'Создать и рисовать',
    zone_map_region: 'Регион',
    zone_map_wipe: 'Стереть контур',
    zone_map_wipe_title: 'Стереть контур?',
    zone_map_wipe_body:
      'Пятно «{{name}}» останется с названием и ценами, но перестанет обслуживать адреса, пока вы не нарисуете новый контур. Само пятно удаляется в списке «Города B2C».',
    zone_map_tool: 'Чем рисовать',
    zone_map_tool_circle: 'Круг',
    zone_map_tool_rect: 'Прямоугольник',
    zone_map_tool_free: 'От руки',
    zone_map_tool_points: 'По точкам',
    zone_map_finish: 'Готово',
    zone_map_hint_cutting:
      'Протяните круг внутри пятна — эта область перестанет обслуживаться. Контур останется прежним, из него вычтется дырка. Закончив, нажмите «Сохранить пятно».',
    zone_map_hint_editing:
      'Тяните вершины, чтобы поправить контур. Потяните середину стороны — появится новая вершина. Тяните за середину фигуры, чтобы подвинуть её целиком. Закончив, нажмите «Сохранить пятно».',
    zone_map_hint_circle:
      'Нажмите в центре района и тяните — круг растянется. Отпустили — готово, дальше можно двигать вершины.',
    zone_map_hint_rect:
      'Нажмите в одном углу и тяните в противоположный. Отпустили — готово, дальше можно двигать вершины.',
    zone_map_hint_free:
      'Нажмите и ведите мышью по границе района, не отпуская. Отпустили — контур замкнётся сам.',
    zone_map_hint_points:
      'Кликайте по карте — каждый клик ставит угол. Закончив, нажмите «Готово». Ctrl+Z снимает последний угол, Esc отменяет всё.',
    zone_map_preliminary: 'Предварительно — точные цифры придут после сохранения.',
    zone_map_probe: 'Что получит клиент здесь',
    zone_map_also_covered: 'Сюда же дотягиваются: {{names}}',
    zone_map_not_served: 'Не обслуживается — точка вне всех пятен.',
    zone_city_label_required: 'Укажите название города.',
    zone_city_label_too_long: 'Название города — не длиннее 64 символов.',
    zone_region_required: 'Выберите регион.',
    zone_lat_invalid: 'Широта — число от -90 до 90.',
    zone_lon_invalid: 'Долгота — число от -180 до 180.',
    zone_radius_invalid: 'Радиус — число больше 0 и не более 500 км.',
    zone_delivery: 'Доставка',
    zone_enabled: 'Активна',
    zone_paused: 'Погашена',
    zone_delivery_free: 'бесплатно',
    zone_beyond: 'свыше',
    zone_delivery_max_short: 'не больше',
    zone_delivery_base: 'Доставка: фикс, ₽',
    zone_delivery_base_hint:
      'Фиксированная плата за выезд, одинаковая для всего города. 0 — не брать.',
    zone_delivery_per_liter: 'Доставка: за литр, ₽',
    zone_delivery_per_liter_hint: 'Добавляется за каждый литр заказа. 0 — не брать.',
    zone_free_distance: 'Включено, км',
    zone_free_distance_hint:
      'Километры, входящие в фикс: ближе этого расстояния от центра города за километры не берём. Не больше радиуса города.',
    zone_delivery_per_km: 'Доставка: за км, ₽',
    zone_delivery_per_km_hint:
      'Берётся за каждый километр свыше включённых. 0 — расстояние на цену не влияет.',
    zone_delivery_max: 'Доставка: не больше, ₽',
    zone_delivery_max_hint:
      'Потолок для всей доставки — чтобы дальний адрес не стоил лишнего. Пусто — без потолка.',
    zone_delivery_price_invalid: 'Цена — число не меньше 0.',
    zone_delivery_per_km_too_high: 'Цена за километр — не больше 500 ₽.',
    zone_delivery_cap_below_base: 'Потолок меньше фикса — фикс тогда никогда не берётся.',
    zone_free_distance_invalid: 'Включённое расстояние — число от 0 до 500 км.',
    zone_free_distance_beyond_radius: 'Включённое расстояние больше радиуса города.',
    zone_min_liters: 'Минимальный заказ, л',
    zone_min_liters_hint:
      'Меньше этого объёма заявку не оформить — иначе выезд не окупается. Порог считается на весь выезд: две машины по 12 л вместе его берут, поодиночке нет. Исключение — бак, в который столько физически не влезает: такую заявку принимаем, но списываем как за минимум, и клиенту говорим об этом до оплаты.',
    zone_max_liters: 'Максимум на выезд, л',
    zone_max_liters_hint:
      'Больше этого объёма заказ не оформить — считается по всему выезду, включая машины, добавленные уже в пути. Пока это просто настройка: остаток в цистерне система ещё не ведёт.',
    zone_min_liters_invalid: 'Минимальный заказ — число больше 0.',
    zone_max_liters_invalid: 'Максимум на выезд — число больше 0.',
    zone_max_liters_too_high: 'Максимум на выезд — не больше 5000 л.',
    zone_max_liters_below_min: 'Максимум меньше минимума — так ни один заказ не пройдёт.',
    zone_urgent_fixed: 'Срочность: фикс, ₽',
    zone_urgent_fixed_hint:
      'Берётся сверх доставки, когда клиент выбрал «Срочно». Такой заказ идёт первым в очереди. 0 — срочность бесплатна.',
    zone_urgent_percent: 'Срочность: процент, %',
    zone_urgent_percent_hint:
      'Считается от топлива и доставки, складывается с фиксом. Можно оставить только одно из двух.',
    zone_dispatch_lead: 'Запас перед окном, мин',
    zone_dispatch_lead_hint:
      'За сколько минут до начала окна заказ уходит водителям, чтобы тот успел доехать к началу. По умолчанию 45.',
    zone_urgent_fixed_invalid: 'Надбавка — число не меньше 0.',
    zone_urgent_percent_invalid: 'Процент — число не меньше 0.',
    zone_urgent_percent_too_high: 'Процент срочности — не больше 100.',
    zone_dispatch_lead_invalid: 'Запас перед окном — от 0 до 240 минут.',
    zone_max_cars: 'Машин в одном выезде',
    zone_max_cars_hint:
      'Сколько машин клиент может заправить одной заявкой по одному адресу. Доставка при этом берётся один раз. По умолчанию 3.',
    zone_max_cars_invalid: 'Машин в выезде — от 1 до 10.',
    zone_service_opens: 'Начало работы',
    zone_service_opens_hint:
      'По Москве. С этого времени принимаем «Срочно» и «Ближайшую», с него же начинается первое окно «Ко времени». По умолчанию 09:00.',
    zone_service_closes: 'Конец работы',
    zone_service_closes_hint:
      'По Москве. Позже этого времени ни одно окно «Ко времени» не заканчивается. 00:00–24:00 — круглосуточно. По умолчанию 21:00.',
    zone_window_length: 'Длина окна доставки',
    zone_window_length_hint:
      'На такие отрезки режется рабочий день — из них клиент выбирает время «Ко времени». Если день не делится поровну, последнее окно короче. По умолчанию 4 часа.',
    zone_order_cutoff: 'Последний срочный заказ',
    zone_order_cutoff_hint:
      'За столько до конца работы перестаём принимать «Срочно» и «Ближайшую». В окно «Ко времени», которое уже идёт, тоже можно записаться, только пока до его конца больше этого времени. «Ко времени» на будущие окна принимаем круглосуточно. По умолчанию за 1 час.',
    zone_order_cutoff_option: 'за {{length}} до конца',
    zone_order_cutoff_zero: 'до самого конца',
    zone_order_cutoff_invalid: 'Последний срочный заказ — от 0 до 4 часов до конца работы.',
    zone_order_cutoff_longer_than_day:
      '«Срочно» и «Ближайшая» не будут приниматься вовсе: время до конца не меньше рабочего дня.',
    zone_asap_preview: '«Срочно» и «Ближайшая»: с {{from}} до {{to}}',
    zone_asap_preview_round: '«Срочно» и «Ближайшая»: круглосуточно',
    zone_asap_preview_never:
      '«Срочно» и «Ближайшая» не будут приниматься — уменьшите время последнего срочного заказа.',
    zone_window_preview: '«Ко времени»:',
    zone_window_preview_empty: 'Окон не получится — проверьте время работы и длину окна.',
    zone_window_leftover:
      'Остаток {{length}} короче получаса — отдельным окном клиенту не предлагается.',
    zone_hours: 'Часы работы',
    zone_hours_summary: '{{hours}} · срочные до {{last}}',
    zone_hours_round: 'круглосуточно',
    zone_clock_hours: 'Часы',
    zone_clock_minutes: 'Минуты',
    zone_hours_short: 'ч',
    zone_minutes_short: 'мин',
    zone_service_time_invalid: 'Время — от 00:00 до 24:00.',
    zone_service_closes_before_opens: 'Закрытие должно быть позже открытия.',
    zone_window_length_invalid: 'Длина окна доставки — от 30 минут до 12 часов.',
    zone_window_longer_than_day:
      'Рабочий день короче одного окна — окна доставки некуда поставить.',
  },
  operators: {
    title: 'Водители',
    show_on_map: 'Показать на карте',
    username: 'Логин',
    password: 'Пароль',
    password_hint: 'Минимум 8 символов; нельзя поменять после создания.',
    first_name: 'Имя',
    last_name: 'Фамилия',
    patronymic: 'Отчество',
    name: 'Имя',
    phone: 'Телефон',
    department: 'Подразделение',
    refuel_car: 'Бензовоз',
    can_take_self: 'Может брать сам',
    show_colors: 'Цветовая разметка',
    refuel_key: 'Ключ заправки',
    refuel_key_hint:
      '16 HEX-символов (iButton/Mifare/EM-Marine) или 19 цифр RFID (PetroPoint/ORPAK, ведущие нули — «+»).',
    refuel_key_generate: 'Сгенерировать',
    refuel_key_copy: 'Копировать',
    refuel_mode: 'Режим',
    refuel_mode_hint:
      'Интеграция — заказы каршеринга на карте. Ручной — водитель считывает номер и заправляет.',
    refuel_mode_integration: 'Интеграция',
    refuel_mode_manual: 'Ручной',
    department_required_manual: 'Для ручного режима укажите подразделение по умолчанию.',
    refuel_key_required_manual: 'Для ручного режима укажите ключ авторизации водителя.',
    show_qr: 'Показать QR',
    qr_intro:
      'Выдать новый пароль и QR-код входа для «{{username}}»? Старый пароль перестанет работать.',
    qr_confirm: 'Выдать QR',
    qr_issued: 'QR-код выдан',
    qr_show_once_warning:
      'Пароль показывается один раз и больше нигде не хранится. Отсканируйте QR в приложении водителя или скопируйте пароль вручную.',
    qr_share: 'Поделиться',
    qr_copy_image: 'Копировать QR',
    online: 'Онлайн',
    active_orders: 'Заказы',
    rating: 'Оценка клиентов',
    rating_count: 'оценок: {{count}}',
    rating_low: 'плохих: {{count}} →',
    providers: 'Провайдеры',
    providers_hint: 'Без выбора водитель видит все каршеринги. Выберите — ограничить.',
    lock: 'Заблокировать',
    unlock: 'Разблокировать',
    locked_badge: 'Заблокирован',
    lock_confirm_intro:
      'Заблокировать доступ для «{{username}}»? Сессии на всех устройствах завершатся немедленно. Действие обратимо — снять блокировку можно в любой момент.',
    lock_confirm_button: 'Заблокировать',
    unlock_confirm_intro: 'Снять блокировку с «{{username}}»?',
    unlock_confirm_button: 'Разблокировать',
    wipe_device: 'Удалённо стереть устройство',
    wipe_confirm_intro:
      'Полный сброс телефона «{{username}}» до заводских настроек (factory reset). Действие НЕОБРАТИМО и применяется только к устройствам в режиме Device Owner.',
    wipe_confirm_type_hint: 'Чтобы подтвердить, введите логин «{{username}}» ниже.',
    wipe_confirm_button: 'Стереть устройство',
    wipe_requested: 'Команда на стирание отправлена. Устройство не может подтвердить выполнение.',
    release_controller: 'Снять привязку к контроллеру',
    release_controller_confirm_intro:
      'Снять привязку «{{username}}» к контроллеру на {{car}}? Бензовоз освободится, и на него сможет сесть сменщик. Заказы водителя останутся за ним — вернуть их в общий пул это отдельное действие.',
    release_controller_confirm_button: 'Снять привязку',
    /* Диспетчер решает по одному признаку: телефон водителя ещё на связи или машина заперта за
       ушедшим. Минуты, а не дата: «был 4 мин назад» отвечает на вопрос сразу. */
    connected_seen_now: 'на связи',
    connected_seen_minutes: 'был {{count}} мин назад',
    connected_seen_hours: 'был {{count}} ч назад',
    connected_seen_days: 'был {{count}} сут назад',
  },
  providers: {
    title: 'Провайдеры',
    code: 'Код',
    name: 'Название',
    integration_url: 'URL интеграции',
    default_department: 'Подразделение по умолчанию',
    active: 'Активен',
    auto_record_video: 'Автозапись видео',
    rotate_token: 'Выпустить токен',
    rotate_intro:
      'Выпуск нового токена для {{provider}}. Прежние токены продолжают работать до явного отзыва.',
    token_name: 'Метка токена',
    token_name_placeholder: 'production / staging / smoke',
    rotate_confirm: 'Выпустить',
    token_issued: 'Новый токен',
    show_once_warning:
      'Этот токен показывается один раз. Скопируйте и сохраните его сейчас — после закрытия окна восстановить нельзя.',
    internal_locked_hint: 'Системный провайдер ручной заправки — токены и удаление недоступны.',
  },
  admins: {
    title: 'Пользователи',
    username: 'Логин',
    name: 'Имя',
    first_name: 'Имя',
    last_name: 'Фамилия',
    active: 'Активен',
    inactive: 'Отключена',
    password: 'Пароль',
    password_hint: 'Минимум 8 символов.',
    password_reset: 'Новый пароль',
    password_reset_hint: 'Оставьте пустым, чтобы не менять.',
    generate_password: 'Сгенерировать',
    copy_password: 'Скопировать',
    password_copied: 'Скопировано',
    roles: 'Роли',
    no_roles: 'Без ролей',
    roles_hint: 'Права всех отмеченных ролей складываются.',
    role_locked:
      'Эту роль вы назначить не можете: в ней есть права, которых нет у вас самих, или права полного доступа.',
    overrides: 'Исключения',
    overrides_title: 'Личные исключения',
    overrides_hint:
      'Право сверх ролей — «Выдать», убрать право, которое дают роли, — «Запретить». Запрет сильнее ролей, но на полный доступ не действует.',
    overrides_only_changed: 'Только исключения',
    overrides_show_all: 'Все права',
    overrides_none: 'Исключений нет.',
    override_inherit: 'Как в ролях',
    override_grant: 'Выдать',
    override_deny: 'Запретить',
    from_roles: 'даёт роль',
    effective: 'Итог',
    full_access_badge: 'Полный доступ',
    permission_count: 'Прав: {{count}}',
    open: 'Открыть',
    deactivate: 'Отключить',
    deactivate_confirm:
      'Отключить учётную запись «{{name}}»? Войти под ней больше не получится, история останется.',
    create_title: 'Новый сотрудник',
    edit_title: 'Сотрудник: {{name}}',
    tab_card: 'Карточка',
    tab_preview: 'Что увидит',
    tab_history: 'История',
    target_locked:
      'У этого сотрудника есть права, которых нет у вас, — изменить его может только тот, у кого они есть, или полный доступ.',
    self_note: 'Это ваша учётная запись: роли и исключения себе — только в пределах своих прав.',
    view_only: 'Только просмотр: права менять сотрудников у вас нет.',
    created: 'Сотрудник создан',
    saved: 'Сохранено',
    deactivated: 'Учётная запись отключена',
    username_taken: 'Такой логин уже занят.',
    search_placeholder: 'Найти право',
  },
  admin_roles: {
    title: 'Роли и права',
    name: 'Название',
    description: 'Описание',
    permissions: 'Права',
    full_access: 'Полный доступ',
    full_access_hint:
      'Всё, включая пользователей и роли. Отдельные права не нужны; запреты на полный доступ не действуют.',
    new_role: 'Новая роль',
    templates_title: 'Начать с шаблона',
    empty_template: 'Пустая роль',
    copy: 'Копировать',
    copy_name: '{{name}} (копия)',
    copy_skipped: 'Не скопировано — выдать это вы не можете: {{list}}.',
    discard: 'Отменить изменения',
    delete_blocked: 'Роль назначена сотрудникам ({{count}}) — сначала снимите её с них.',
    delete_confirm: 'Удалить роль «{{name}}»?',
    system_badge: 'Системная',
    system_locked: 'Системная роль: всегда полный доступ. Права не меняются, удалить нельзя.',
    readonly_no_edit: 'Только просмотр: права менять роли у вас нет.',
    readonly_wider:
      'В роли есть права, которых нет у вас, или права полного доступа, — изменить её вы не можете.',
    stats: 'Прав: {{permissions}} · сотрудников: {{admins}}',
    stats_full: 'Полный доступ · сотрудников: {{admins}}',
    tab_permissions: 'Права',
    tab_preview: 'Что увидит сотрудник',
    tab_history: 'История',
    search_placeholder: 'Найти право',
    section_counter: '{{checked}} из {{total}}',
    whole_section: 'Весь раздел',
    requires: 'Нужно: {{list}}',
    privileged_badge: 'Только полный доступ',
    locked_privileged: 'Выдаёт только сотрудник с полным доступом.',
    locked_not_mine: 'Этого права нет у вас самих.',
    expand_all: 'Развернуть все',
    collapse_all: 'Свернуть все',
    unsaved_title: 'Изменения не сохранены',
    unsaved_body: 'Уйти без сохранения?',
    unsaved_leave: 'Уйти',
    created: 'Роль создана',
    saved: 'Роль сохранена',
    deleted: 'Роль удалена',
    name_taken: 'Роль с таким названием уже есть.',
    name_required: 'Укажите название.',
    pick_role: 'Выберите роль или создайте новую.',
    no_roles: 'Ролей пока нет.',
    no_matches: 'Ничего не нашлось.',
    empty_warning: 'В роли нет ни одного права: сотрудник увидит только экран «Нет доступа».',
  },
  access_preview: {
    full_access: 'Полный доступ: откроется всё, включая пользователей и роли.',
    pages_title: 'Откроются страницы',
    no_pages: 'Ни одна страница не откроется — только экран «Нет доступа».',
    start_page: 'После входа откроется «{{page}}».',
    actions_title: 'Может делать',
    closed_sections: 'Нет доступа: {{list}}.',
  },
  access_history: {
    empty: 'Изменений пока не было.',
    system_actor: 'Система',
    action_create: 'Создание',
    action_update: 'Изменение',
    action_delete: 'Удаление',
    action_deactivate: 'Отключение',
    permissions_added: 'Выдано: {{list}}',
    permissions_removed: 'Снято: {{list}}',
    renamed: 'Название: «{{from}}» → «{{to}}»',
    description_changed: 'Описание изменено',
    roles_added: 'Роли добавлены: {{list}}',
    roles_removed: 'Роли сняты: {{list}}',
    grant_added: 'Выдано лично: {{list}}',
    deny_added: 'Запрещено лично: {{list}}',
    override_removed: 'Исключение снято: {{list}}',
    person_renamed: 'Имя: {{from}} → {{to}}',
    no_access_changes: 'Права не менялись (имя или пароль).',
    created_with: 'Прав: {{count}}',
  },
  pricing: {
    set_override: 'Новый прайс',
    edit_override: 'Изменить прайс',
    region: 'Регион',
    provider: 'Провайдер',
    fuel: 'Топливо',
    unit_price: 'Цена за литр',
    services: 'Услуги',
    fuel_section: 'Топливо',
    delivery: 'Доставка',
    surcharges: 'Доплаты (по запросу)',
    surcharges_toggle_show: 'Показать доплаты',
    surcharges_toggle_hide: 'Скрыть доплаты',
    rate: 'Ставка',
    billing_unit: 'Единица',
    billing_per_litre: 'За литр',
    billing_per_order: 'За выезд',
    billing_fixed: 'Фикс',
    unit_short_per_litre: '₽/л',
    unit_short_per_order: '₽/выезд',
    unit_short_fixed: '₽',
    threshold: 'Порог, л',
    threshold_suffix: 'при < {{n}} л',
    history: 'История',
    empty: 'Прайсов пока нет.',
    active: 'Активно',
    closed: 'Закрыто',
    triple_required: 'Выберите регион, провайдера и топливо.',
    none: '—',
    preview_liters: 'Литров для расчёта',
    preview_total: 'Расчёт за {{n}} л',
    preview_plus_surcharges: '+ доплаты по запросу',
    surcharges_count: '{{n}} доплат',
    kind_fuel: 'Топливо',
    kind_service: 'Услуга',
  },
  personal_car_settings: {
    title: 'Отмена и неявка клиента',
    subtitle:
      'Настройки применяются только к заказам «Личный автомобиль» (B2C). Штраф за отмену/неявку — это цена услуги «Доставка» из прайса, настраивается на странице «Цены».',
    wait_label: 'Время ожидания доступа к машине, мин.',
    wait_helper:
      'Если водитель приехал, а клиент не обеспечил доступ к машине за это время — заказ автоматически отменяется как неявка, штраф (стоимость доставки) списывается с холда, остаток возвращается.',
    save: 'Сохранить',
    saved: 'Настройки сохранены',
    save_failed: 'Не удалось сохранить',
    load_failed: 'Не удалось загрузить настройки',
    range_hint: 'От 1 до 120 минут',
  },
  stuck: {
    money_at_stake: 'Заперто денег клиентов',
    total_label: 'Операций',
    explainer:
      'Здесь операции, которые не доехали до банка или кассы и больше не будут пробовать сами. Пока строка тут — деньги клиента заперты: холд не снят или возврат не сделан. «Повторить» возвращает в очередь ту же самую операцию, поэтому списать дважды она не может, а наполовину выполненную — доведёт до конца.',
    col_operation: 'Что не выполнено',
    col_order: 'Заказ',
    col_money: 'Сумма',
    col_since: 'Ждёт с',
    col_error: 'На чём встало',
    kind_RELEASE: 'вернуть клиенту',
    kind_REFUND: 'вернуть клиенту',
    kind_CAPTURE: 'списать нам',
    kind_RECEIPT: 'чек',
    retry: 'Повторить',
    retry_all: 'Повторить все',
    retry_all_title: 'Отправить все операции заново',
    retry_all_confirm:
      'Операций к отправке: {{n}}. Каждая продолжится с того места, где остановилась.',
    retry_all_note:
      'Отправляйте, когда причина отказа устранена — например, банк открыл права. Пока причина та же, операции снова исчерпают попытки.',
    retry_queued: 'Операция отправлена заново',
    retry_all_queued: 'Отправлено заново: {{n}}',
    retry_failed: 'Не удалось отправить заново',
    not_retriable_hint: 'Эту операцию повтор не починит — сломан её состав, нужна правка в коде',
    empty: 'Незавершённых операций нет — все деньги дошли',
  },
  consumers: {
    col_email: 'Почта',
    col_status: 'Статус',
    col_registered_at: 'Регистрация',
    col_orders: 'Заказы (активные / всего)',
    col_unpaid_overflow: 'Долг',
    col_deletion_request: 'Удаление',
    deletion_pending: 'Запрошено',
    refuels: 'Заправки',
    change_status: 'Статус',
    change_status_title: 'Изменить статус клиента',
    filter_status: 'Статус:',
    filter_all: 'Все',
    search_placeholder: 'Поиск по почте',
    total: 'Всего: {{n}}',
    empty: 'Клиентов нет.',
    prev: 'Назад',
    next: 'Вперёд',
    status_ACTIVE: 'Активен',
    status_SUSPENDED: 'Заблокирован',
    status_UNDER_REVIEW: 'На проверке',
    status_hint_ACTIVE: 'Клиент может создавать заказы.',
    status_hint_SUSPENDED: 'Клиент не сможет создать новый заказ — приложение покажет отказ.',
    status_hint_UNDER_REVIEW:
      'Пометка для поддержки: на заказы не влияет, клиент ничего не заметит.',
    active_orders_warning:
      'У клиента сейчас активных заказов: {{n}}. Смена статуса их не отменит и не вернёт деньги — заправка состоится.',
    col_discount: 'Скидка',
    discount_pair: 'топливо −{{fuel}} % / услуги −{{service}} %',
    change_discount: 'Скидка',
    change_discount_title: 'Скидка клиента',
    fuel_discount: 'Скидка на топливо, %',
    service_discount: 'Скидка на услуги, %',
    discount_range: 'От 0 до 100.',
    discount_applies_hint:
      'Действует со следующего заказа. Заказы, которые уже едут, останутся с прежней скидкой — деньги на карте заморожены именно под неё.',
  },
  chat: {
    read_only: 'Только чтение: писать в эту переписку у вас нет права.',
    approval_waiting: 'Ждёт решения диспетчера.',
    new_message_title: 'Новое сообщение в чате',
    new_approval_title: 'Требуется одобрение заправки',
    tab_operators: 'Водители',
    tab_consumers: 'Клиенты',
    operators_label: 'Список водителей',
    back_to_operators: 'К списку водителей',
    no_operators: 'Водителей нет.',
    pick_operator: 'Выберите водителя слева.',
    consumers_label: 'Список клиентов',
    back_to_consumers: 'К списку клиентов',
    no_consumers: 'Нет обращений и клиентов с заказом в работе.',
    pick_consumer: 'Выберите клиента слева.',
    consumer_fallback_label: 'Клиент {{id}}',
    consumer_plates_more: '{{plate}} +{{count}}',
    consumer_open_order: 'Заказ в работе — открыть',
    message_placeholder_consumer: 'Сообщение клиенту…',
    typing_consumer: 'клиент печатает…',
    empty: 'Сообщений ещё нет.',
    message_input: 'Сообщение',
    message_placeholder: 'Сообщение водителю…',
    send: 'Отправить',
    read: 'прочитано',
    read_mark: '✓✓',
    unread: '{{count}} непрочитанных',
    typing: 'водитель печатает…',
    attach_file: 'Прикрепить фото',
    record: 'Записать голосовое',
    stop_record: 'Стоп',
    cancel_record: 'Отменить запись',
    recording: 'Идёт запись…',
    remove_attachment: 'Убрать вложение',
    attachment_loading: 'Загрузка вложения…',
    attachment_failed: 'Не удалось загрузить вложение',
    image_alt: 'Вложение-изображение',
    download_file: 'Скачать файл',
    mic_error: 'Нет доступа к микрофону',
    approval_title: 'Запрос подтверждения',
    open_order: 'Открыть заказ',
    approve: 'Одобрить',
    reject: 'Отклонить',
    approved: 'Одобрено',
    rejected: 'Отклонено',
  },
  refill: {
    operator: 'Водитель',
    requested_at: 'Запрошена',
    status: 'Статус',
    decline_reason: 'Причина отказа',
    fuel_station: 'АЗС',
    station_optional: 'необязательно',
    approve: 'Одобрить',
    decline: 'Отклонить',
    approve_title: 'Одобрить заявку',
    decline_title: 'Отклонить заявку',
    empty: 'Заявок нет.',
    status_PENDING: 'Ожидают',
    status_APPROVED: 'Одобренные',
    status_DECLINED: 'Отклонённые',
    status_COMPLETED: 'Выполненные',
    status_CANCELLED: 'Отменённые',
  },
  reports: {
    from: 'С даты',
    to: 'По дату',
    download: 'Скачать XLSX',
    completed_orders: 'Завершённые заказы',
    operators_summary: 'Сводка по водителям',
    providers_summary: 'Сводка по провайдерам',
    last_size: 'Размер файла: {{bytes}} байт.',
    open_builder: 'Конструктор отчётов',
  },
  report_builder: {
    title: 'Конструктор отчётов',
    subtitle: 'Любое поле — в любой отчёт: колонки, фильтры, группировки и живой предпросмотр',
    recipients_label: 'Доступно клиентам',
    recipients_hint: 'Отмеченные клиенты увидят этот отчёт в своём кабинете',
    catalog_title: 'Каталог полей',
    catalog_search: 'Найти поле…',
    catalog_unavailable: 'Каталог полей недоступен — бэкенд не отвечает. Попробуйте позже.',
    catalog_retry: 'Повторить',
    catalog_empty_search: 'Ничего не нашлось по «{{query}}».',
    section_columns: 'Колонки',
    section_filters: 'Фильтры',
    section_group: 'Группировка',
    section_aggregates: 'Агрегаты',
    section_sort: 'Сортировка',
    columns_empty: 'Кликните поле в каталоге слева — оно станет колонкой отчёта.',
    columns_drag_hint: 'Порядок чипов = порядок колонок в файле. Перетаскивайте, чтобы поменять.',
    filters_empty:
      'Без фильтров отчёт соберётся по всем данным. Добавьте условие, чтобы сузить выборку.',
    add_condition: 'Условие',
    add_group: 'Группа ИЛИ',
    logic_and: 'И',
    logic_or: 'ИЛИ',
    logic_and_hint: 'выполняются все условия',
    logic_or_hint: 'достаточно любого условия',
    group_remove: 'Удалить группу',
    condition_field_placeholder: 'Поле',
    condition_op_label: 'Сравнение',
    condition_value_placeholder: 'Значение',
    condition_values_placeholder: 'Значение + Enter',
    condition_remove: 'Удалить условие',
    between_from: 'от',
    between_to: 'до',
    group_by_empty: 'Сгруппируйте строки — например, по виду топлива или по неделям.',
    add_group_by: 'Группировка',
    aggregates_hint: 'Итоги по каждой группе: сумма, среднее, количество…',
    aggregates_empty: 'Добавьте итог по метрике — без него группы покажут только ключи.',
    add_aggregate: 'Агрегат',
    aggregate_metric_placeholder: 'Метрика',
    aggregate_fn_placeholder: 'Функция',
    sort_empty: 'Без сортировки строки идут в порядке базы.',
    add_sort: 'Сортировка',
    sort_dir_label: 'Направление',
    dir_asc: 'по возрастанию',
    dir_desc: 'по убыванию',
    preview_title: 'Предпросмотр',
    preview_rows: '{{total}} строк · показаны первые {{shown}}',
    preview_rows_exact: 'Строк: {{total}}',
    preview_truncated:
      'Показаны первые {{shown}} строк из {{total}} — сузьте фильтр, если нужны все.',
    preview_start_title: 'Начните с колонок',
    preview_fix_title: 'Почти готово',
    preview_empty: 'Запрос выполнен, но строк нет. Ослабьте фильтры или расширьте период.',
    preview_error_cost_title: 'Запрос слишком тяжёлый',
    preview_error_busy: 'Отчёт уже считается — подождите немного и попробуйте снова.',
    preview_error_bad_input: 'Сервер отклонил запрос: {{message}}',
    preview_error_forbidden: 'Недостаточно прав для этого набора полей.',
    preview_error_unavailable: 'Бэкенд недоступен. Предпросмотр обновится, когда появится связь.',
    name_placeholder: 'Название отчёта',
    saved_select_placeholder: 'Сохранённые отчёты',
    new_report: 'Новый отчёт',
    delete_report: 'Удалить отчёт',
    delete_confirm: 'Удалить отчёт «{{name}}»? Действие необратимо.',
    download_xlsx: 'Скачать XLSX',
    download_pdf: 'Скачать PDF',
    saved_toast: 'Отчёт сохранён',
    deleted_toast: 'Отчёт удалён',
    name_required: 'Дайте отчёту название, чтобы сохранить.',
    definition_broken: 'Сохранённый отчёт не читается — возможно, создан другой версией.',
    issue_no_columns: 'Добавьте хотя бы одну колонку из каталога слева.',
    issue_condition_no_field: 'В фильтре есть условие без поля — выберите поле или удалите строку.',
    issue_condition_no_value: 'Заполните значение условия в фильтре.',
    issue_condition_bad_number: 'Значение условия должно быть числом.',
    issue_between_incomplete: 'Для «между» нужны обе границы.',
    issue_between_inverted: 'Левая граница «между» больше правой.',
    issue_group_by_incomplete: 'Выберите поле группировки или удалите пустую строку.',
    issue_aggregate_incomplete: 'Выберите метрику и функцию агрегата.',
    issue_sort_incomplete: 'Выберите поле сортировки или удалите пустую строку.',
    client_subtitle: 'Соберите отчёт по своим заправкам: колонки, фильтры и живой предпросмотр',
    client_stub_title: 'Конструктор не подключён',
    client_stub_body: 'Обратитесь к менеджеру, чтобы вам подключили конструктор отчётов.',
    client_unavailable_title: 'Конструктор временно недоступен',
    client_unavailable: 'Сервис не отвечает. Попробуйте позже.',
  },
  report_fields: {
    category_order: 'Заказ',
    category_geo: 'Гео и расстояния',
    category_fuel: 'Топливо и цены',
    category_services: 'Услуги',
    category_operator: 'Водитель',
    category_provider: 'Провайдер',
    category_fleet: 'Парк и техника',
    category_media: 'Медиа',
    category_chat: 'Чат',
    category_cancellation: 'Отмены',
    category_audit: 'Аудит',
    kind_dimension: 'дименшн',
    kind_measure: 'метрика',
    kind_timestamp: 'дата',
    sensitivity_pricing: 'цены',
    sensitivity_media: 'медиа',
    sensitivity_internal: 'служебное',
    op_eq: 'равно',
    op_ne: 'не равно',
    op_lt: 'меньше',
    op_le: 'не больше',
    op_gt: 'больше',
    op_ge: 'не меньше',
    op_in: 'любое из',
    op_not_in: 'ни одно из',
    op_between: 'между',
    op_is_null: 'пусто',
    op_not_null: 'не пусто',
    op_contains: 'содержит',
    agg_sum: 'сумма',
    agg_avg: 'среднее',
    agg_min: 'минимум',
    agg_max: 'максимум',
    agg_count: 'количество',
    agg_count_distinct: 'уникальные',
    granularity_day: 'День',
    granularity_week: 'Неделя',
    granularity_month: 'Месяц',
  },
  clients: {
    subtitle: 'Кабинеты каршерингов — доступ к своим завершённым заправкам',
    create: 'Создать кабинет',
    reports_title: 'Отчёты клиента',
    reports_subtitle: 'Отметьте отчёты, которые клиент увидит в своём кабинете',
    reports_unavailable: 'Не удалось загрузить список отчётов',
    reports_none_available: 'У вас пока нет сохранённых отчётов. Соберите отчёт в конструкторе.',
    username: 'Логин',
    password: 'Пароль',
    password_auto_hint: 'Сгенерирован автоматически. Скопируйте и передайте клиенту.',
    regenerate: 'Сгенерировать заново',
    company: 'Компания',
    company_placeholder: 'BelkaCar',
    company_select: 'Выберите компанию',
    providers: 'Провайдеры',
    providers_required:
      'Выберите хотя бы одного провайдера — иначе кабинет не увидит ни одной заправки.',
    internal_provider_warning: 'системный провайдер ручной заправки — рекомендуем убрать',
    regions: 'Регионы',
    regions_hint: 'Пусто — все регионы.',
    fuel_types: 'Топливо',
    fuel_hint: 'Пусто — все виды топлива.',
    can_view_media: 'Видит видео заправок',
    can_export: 'Может строить отчёты (XLSX/PDF)',
    can_view_pricing: 'Видит цены',
    completed_only: 'Только завершённые заказы',
    date_from: 'Видит заказы с даты',
    date_to: 'Видит заказы по дату',
    dates_hint: 'Пусто — без ограничения по датам (видит все свои заправки).',
    created_title: 'Кабинет создан',
    created_hint:
      'Передайте клиенту логин и пароль. Вход — по тому же адресу, что и админка. Пароль показывается один раз.',
    copy_credentials: 'Копировать логин и пароль',
    review_hint: 'Проверьте настройки и создайте кабинет.',
    step: 'Шаг {{n}} из {{total}}',
    next: 'Далее',
    back: 'Назад',
    finish: 'Создать кабинет',
    step_access: 'Доступ',
    step_providers: 'Провайдеры',
    step_regions: 'Регионы',
    step_scope: 'Топливо',
    step_permissions: 'Права',
    step_review: 'Проверка',
    err_username: 'Логин — минимум 3 символа.',
    err_password: 'Пароль — минимум 8 символов.',
    err_providers: 'Выберите хотя бы одного провайдера.',
    all: 'все',
    none: 'нет',
    yes: 'да',
    no: 'нет',
    col_provider_scope: 'Провайдеры',
    col_permissions: 'Права',
    col_active: 'Активен',
    perm_media: 'видео',
    perm_export: 'отчёты',
    perm_pricing: 'цены',
    edit_title: 'Кабинет клиента',
    scope_section: 'Область видимости',
    flags_section: 'Права и окно дат',
    report_builder_section: 'Конструктор отчётов',
    can_build_reports: 'Может собирать свои отчёты в конструкторе',
    report_fields_hint:
      'Отметьте поля, доступные кабинету в конструкторе. Пустой набор — клиент не увидит ни одного поля.',
    report_fields_unavailable:
      'Каталог полей недоступен — бэкенд не отвечает. Набор полей при сохранении не изменится.',
    report_fields_pricing_locked: 'Недоступно: у кабинета нет права «Видит цены».',
    report_fields_select_all: 'Выбрать все',
    report_fields_clear_all: 'Снять все',
    report_fields_selected_n: 'Выбрано полей: {{n}}',
    reset_password: 'Сбросить пароль',
    reset_password_intro:
      'Выдать новый пароль для «{{username}}»? Старый пароль перестанет работать.',
    reset_password_confirm: 'Выдать новый пароль',
    password_issued: 'Пароль выдан',
    password_show_once_warning:
      'Пароль показывается один раз и больше нигде не хранится. Скопируйте и передайте клиенту.',
  },
  client_reports: {
    title: 'Отчёты',
    subtitle: 'Отчёты, подготовленные для вас',
    empty_title: 'Пока нет отчётов',
    empty_body: 'Здесь появятся отчёты, которые для вас соберёт менеджер.',
    unavailable: 'Не удалось загрузить отчёты. Повторите попытку.',
    download_failed: 'Не удалось скачать отчёт',
  },
  client_cabinet: {
    brand: 'Кабинет клиента',
    title: 'Заправки',
    nav_builder: 'Конструктор отчётов',
    subtitle: 'Ваши завершённые заправки',
    filter_from: 'С даты',
    filter_to: 'По дату',
    filter_car: 'Гос. номер',
    apply: 'Применить',
    reset: 'Сбросить',
    export_xlsx: 'Экспорт XLSX',
    export_pdf: 'Экспорт PDF',
    col_datetime: 'Дата и время',
    col_truck: 'Бензовоз',
    col_driver: 'Водитель',
    col_car: 'Авто',
    col_make: 'Марка техники',
    col_city: 'Город',
    col_fuel: 'ГСМ',
    col_liters: 'Кол-во',
    col_price: 'Цена',
    col_fuel_sum: 'Сумма',
    col_delivery: 'Доставка',
    col_services: 'Сумма услуг',
    col_total: 'Сумма итого',
    col_external: 'Внешний ID',
    col_state: 'Статус',
    col_unit_price: 'Цена/л',
    col_completed: 'Завершён',
    col_video: 'Видео',
    col_photo: 'Фото',
    watch: 'Смотреть',
    videos_title: 'Видео заправки',
    photos_title: 'Фото заправки',
    no_videos: 'Видео нет.',
    no_photos: 'Фото нет.',
    download: 'Скачать',
    loading_video: 'Загрузка видео…',
    loading_photo: 'Загрузка фото…',
    video_failed: 'Не удалось загрузить видео.',
    photo_failed: 'Не удалось загрузить фото.',
    total_count: 'Всего: {{n}}',
    prev: 'Назад',
    next: 'Вперёд',
    empty: 'Заправок нет.',
    state_completed: 'Завершён',
  },
} as const;

export type Resources = typeof ru;
